/* eslint-disable */
import React, {useCallback, useContext, useEffect, useState} from "react";
import useHttp from "../../hooks/use-http";
import {useParams} from "react-router-dom";
import CardContext from "../../store/card-context";
import BusinessLogo from "../../assets/images/Logo.png";
import {notifySuccess, notifyRedirecting} from "../../utils/embedHelper";

const CardSuccessful = () => {
    const [transactionDetails, setTransactionDetails] = useState({});
    const [statusMessage, setStatusMessage] = useState("");
    const [status, setStatus] = useState("");
    const [data, setData] = useState({});
    const [time, setTime] = useState(5);
    const {sendRequest: getTransaction} = useHttp();
    const {isLoading, sendRequest: getTransactionStatus} = useHttp();
    const {setIsDeclined} = useContext(CardContext);

    const {id, prefix} = useParams();

    const fetchTransactionInfo = (data) => {
        setTransactionDetails(data);
    };

    const fetchTransaction = useCallback(() => {
        getTransaction(
            {
                url: `${process.env.REACT_APP_BASE_URL}/api/transaction/${id}`,
                headers: {"Content-Type": "application/json"},
            },
            fetchTransactionInfo
        );
    }, [getTransaction, id]);

    useEffect(() => {
        const fetchData = async () => {
            await fetchTransaction();
        };
        fetchData();
    }, [fetchTransaction]);

    const confirmStatus = useCallback((data) => {
        setData(data);
        setStatus(data?.data?.status);
        if (data?.data?.status) {
            setStatusMessage(data?.data?.statusMessage);
            notifySuccess(data?.data || {reference: id, status: data?.data?.status});
        }
    }, [id]);

    const fetchTransactionStatus = useCallback(() => {
        getTransactionStatus(
            {
                url: `${process.env.REACT_APP_BASE_URL}/api/transaction/status/${id}`,
                headers: {"Content-Type": "application/json"},
            },
            confirmStatus
        );
    }, [confirmStatus, getTransactionStatus, id]);

    useEffect(() => {
        const getStatus = async () => {
            await fetchTransactionStatus();
        };
        getStatus();
        const fetchTransactionStatus2 = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/api/transaction/status/${id}`,
                    {
                        method: "GET",
                        headers: {"Content-Type": "application/json"},
                        body: null,
                    }
                );

                if (!response.ok) {
                    throw new Error("Request failed!");
                }

                const data = await response.json();
                setStatus(data?.data?.status);
                if (data?.data?.status) {
                    setStatusMessage(data?.data?.statusMessage);

                    //     let interval = setInterval(() => {
                    //       setTime((prevTime) => {
                    //         if (prevTime <= 1) {
                    //           clearInterval(interval);
                    //           window.location.href = data?.data?.returnUrl;
                    //           return 0;
                    //         } else {
                    //           return prevTime - 1;
                    //         }
                    //       });
                    //     }, 1000);
                    let interval;
                    if (time > 0) {
                        interval = setInterval(() => {
                            setTime((prevTime) => prevTime - 1);
                        }, 1000);
                    } else {
                        // Redirect when the timer reaches 0
                        clearInterval(interval);
                        window.location.href = data?.data?.returnUrl;
                    }
                }
            } catch (err) {
                setError(err.message || "Something went wrong!");
            }
            setIsLoading(false);
        };
        return () => {
            clearInterval(interval);
        };
        fetchTransactionStatus2();
    }, [fetchTransactionStatus]);

    const isSuccess = status?.toLowerCase() === "approved" || status?.toLowerCase() === "success" || status?.toLowerCase() === 'successful';
    useEffect(() => {
        let interval;
        if (time > 0) {
            interval = setInterval(() => {
                setTime((prevTime) => prevTime - 1);
            }, 1000);
        } else {
            localStorage.removeItem("AppName");
            // Redirect when the timer reaches 0
            clearInterval(interval);
            if (data?.data?.returnUrl) {
                notifyRedirecting({returnUrl: data?.data?.returnUrl, status: status, reference: id});
                window.location.href = data?.data?.returnUrl;
            }
        }

        return () => {
            clearInterval(interval);
        };
    }, [time, data?.data?.returnUrl]);

    // useEffect(() => {
    //   if (!id) return;
    //   if (status && status?.toLowerCase() !== "approved" && status?.toLowerCase() !== "success" && status?.toLowerCase() !== 'successful') {
    //     setIsDeclined(true);
    //     localStorage.setItem("isDeclined", JSON.stringify(true));
    //
    //     const timeout = setTimeout(() => {
    //       window.location.href = `/${id}`;
    //     }, 4000);
    //
    //     return () => clearTimeout(timeout);
    //   }
    // }, [status, id]);

    const currentCurrency = transactionDetails?.data?.currency || "NGN";
    const formattedCurrencySymbol = currentCurrency === "NGN" ? "₦" : currentCurrency;
    const shoppingCartAmount = transactionDetails?.data?.amount || 0;
    const processingFeeAmount = transactionDetails?.data?.fee || 0;
    const totalAmount = shoppingCartAmount + processingFeeAmount;


    if (isLoading) {
        return (
            <div
                className="min-h-screen bg-[#5d7c8f] bg-blend-overlay flex items-center justify-center p-4 bg-cover bg-no-repeat bg-center bg-[url('../src/assets/images/background.png')] font-sans">
                <div
                    className="w-full max-w-[500px] bg-white rounded-none border border-slate-200 p-8 flex items-center justify-center min-h-[360px] animate-pulse">
                    <div className="text-slate-400 font-semibold">Loading...</div>
                </div>
            </div>
        );
    }

    return (
        <div
            className="min-h-screen bg-[#5d7c8f] bg-blend-overlay flex items-center justify-center p-4 bg-cover bg-no-repeat bg-center bg-[url('../src/assets/images/background.png')] font-sans">
            <div
                className="w-full max-w-[500px] bg-white rounded-none shadow-none border border-slate-200 flex flex-col justify-between min-h-[460px] p-8">
                <div>
                    {/* Logo & Amount Header */}
                    <div className="flex justify-between items-start border-b border-slate-100 pb-6 mb-6">
                        <div>
                            <img src={BusinessLogo} alt="Payloft" className="h-6 w-auto mb-2"/>
                            <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">Merchant</p>
                            <h4 className="text-sm font-extrabold text-slate-800 uppercase mt-0.5">
                                {transactionDetails?.data?.merchantName || "Merchant"}
                            </h4>
                        </div>
                        <div className="text-right">
                            <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">Paid Amount</p>
                            <h3 className="text-xl font-bold text-slate-800 mt-1">
                                {formattedCurrencySymbol}{totalAmount.toLocaleString()}
                            </h3>
                            <p className="text-[11px] text-slate-400 mt-0.5">
                                {transactionDetails?.data?.email}
                            </p>
                        </div>
                    </div>

                    {/* Success/Failed status icon & text */}
                    <div className="text-center space-y-4 my-8">
                        <div className="flex justify-center">
                            {isSuccess ? (
                                <div
                                    className="w-16 h-16 bg-green-50 border border-green-200 text-green-500 rounded-full flex items-center justify-center">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                </div>
                            ) : (
                                <div
                                    className="w-16 h-16 bg-red-50 border border-red-200 text-red-500 rounded-full flex items-center justify-center">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                </div>
                            )}
                        </div>

                        <div className="space-y-1 px-4">
                            <h3 className="text-lg font-bold text-slate-800">
                                {isSuccess ? "Transaction Successful" : "Transaction Failed"}
                            </h3>
                            <p className="text-xs text-slate-500 leading-relaxed">
                                {prefix === "transfer"
                                    ? "Payment Received! Your transfer has been verified. Redirecting you to the merchant—do not close this window."
                                    : statusMessage || (isSuccess ? "Your transaction was successful." : "Your transaction was not successful.")}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Redirect timer & Secure badge footer */}
                <div className="space-y-6 pt-4 border-t border-slate-100">
                    {isSuccess && (
                        <div className="flex justify-center">
                            <div
                                className="w-full text-center py-3 bg-[#f8fafc] border border-slate-200 text-slate-600 font-semibold text-xs rounded-lg">
                                Redirecting in 00:{time.toString().padStart(2, "0")}s
                            </div>
                        </div>
                    )}

                    {/* Secure Lock Badge */}
                    <div className="flex justify-center">
                        <div
                            className="px-5 py-2.5 border border-slate-200 rounded-lg bg-white flex items-center justify-center gap-2">
                            <svg width="12" height="14" viewBox="0 0 14 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect y="5" width="14" height="11" rx="2" fill="#f5a623"/>
                                <path d="M3 5V4.5C3 2.567 4.567 1 6.5 1V1C8.433 1 10 2.567 10 4.5V5" stroke="#f5a623"
                                      strokeWidth="2" strokeLinecap="round"/>
                                <circle cx="7" cy="10.5" r="1.5" fill="white"/>
                            </svg>
                            <span
                                className="text-[10px] text-slate-500 font-extrabold uppercase tracking-widest leading-none">
                Powered by Payloft
              </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardSuccessful;
